/** @jsx jsx */
import PropTypes from 'prop-types'
import { Flex, jsx, Spinner, Text } from 'theme-ui'
import MinusIcon from '~/assets/images/icons/minus.inline.svg'
import PlusIcon from '~/assets/images/icons/plus.inline.svg'
import QuantityIncrementorButton from '~/components/Generic/QuantityIncrementor/Button'

const QuantityIncrementor = ({
  disableChange,
  handleChange,
  isLoading,
  quantity,
}) => {
  return (
    <Flex sx={{ pointerEvents: isLoading ? 'none' : 'auto' }}>
      <QuantityIncrementorButton
        disabled={disableChange}
        label={`Decrease quantity of ${quantity} by 1`}
        onClick={() => handleChange(quantity - 1)}
      >
        <MinusIcon sx={{ width: '10px' }} />
      </QuantityIncrementorButton>
      <Flex
        sx={{
          alignItems: 'center',
          backgroundColor: 'white',
          border: '1px solid',
          borderColor: 'greyLight',
          justifyContent: 'center',
          width: ['32px', '40px'],
        }}
      >
        <Text as="p" color="black" variant="title6">
          {isLoading && (
            <Spinner
              size="20"
              color="inherit"
              sx={{
                position: 'relative',
                top: '2px',
                '@media (prefers-reduced-motion)': {
                  circle: {
                    animationIterationCount: 8,
                  },
                },
              }}
            />
          )}
          {!isLoading && quantity}
        </Text>
      </Flex>
      <QuantityIncrementorButton
        disabled={disableChange}
        label={`Increase quantity of ${quantity} by 1`}
        onClick={() => handleChange(quantity + 1)}
      >
        <PlusIcon sx={{ width: '10px' }} />
      </QuantityIncrementorButton>
    </Flex>
  )
}

QuantityIncrementor.propTypes = {
  handleChange: PropTypes.func,
}

export default QuantityIncrementor
